import React from 'react';

export default function ProductDocSectionHeader({ subtitle, title, description }) {
  return (
    <div className="section__header" style={{ margin: '0 auto', textAlign: 'center' }}>
      <div className="section__subtitle">{subtitle}</div>
      <h1 className="section__title">{title}</h1>
      <div className="section__description">{description}</div>
    </div>
  );
}
